import React from 'react';
import { Box } from '@mui/material';
import { FormSection } from '../../form/FormSection';
import { ResponsiveInput } from '../../form/ResponsiveInput';
import { FORM_SECTIONS } from '../../../config/formSections';
import { FORM_STYLES } from '../../../styles/formStyles';
import { FormValues } from '../CreateStep1V3';

interface RentalPeriodSectionProps {
  values: FormValues;
  handleChange: (name: string) => (value: any) => void;
}

export const RentalPeriodSection: React.FC<RentalPeriodSectionProps> = ({
  values,
  handleChange
}) => {
  const sectionConfig = FORM_SECTIONS.rentalPeriod;

  return (
    <FormSection
      icon={sectionConfig.icon}
      iconColor={sectionConfig.color}
      title={sectionConfig.titleKey}
    >
      <Box sx={FORM_STYLES.layout.twoColumn}>
        <ResponsiveInput
          label="Från datum"
          value={values.fromDate}
          onChange={handleChange('fromDate')}
          type="date"
        />

        <ResponsiveInput
          label="Till datum"
          value={values.toDate}
          onChange={handleChange('toDate')}
          type="date"
        />
      </Box>
    </FormSection>
  );
}; 